import {
  type PaymentStatusPayload,
  PaymentStatusPayloadSchema,
  type SubscriptionStatusPayload,
  SubscriptionStatusPayloadSchema,
} from "@mytour/shared";
import axios from "axios";

export const subscriptionApiService = {
  async getSubscription(): Promise<SubscriptionStatusPayload> {
    const result = await axios.get("api/order/subscription");
    return SubscriptionStatusPayloadSchema.parse(result.data);
  },

  async getPaymentStatus(): Promise<PaymentStatusPayload> {
    const result = await axios.get("api/order/payment-status");
    return PaymentStatusPayloadSchema.parse(result.data);
  },
};
